<template>
  <div class="mt-4 text-right" v-if="Number(total_rows) > 0">
    <nav class="isolate inline-flex -space-x-px rounded-md shadow-sm bg-white" aria-label="Pagination">
      <a @click="changePage(current_page > 1 ? current_page - 1 : 1)"
        class="cursor-pointer relative inline-flex items-center rounded-l-md px-2 py-2 text-gray-400 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0">
        <span class="sr-only">Previous</span>
        <i class="fas fa-chevron-left" aria-hidden="true" />
      </a>
      <!-- Current: "z-10 bg-lime-600 text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-lime-600", Default: "text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:outline-offset-0" -->

      <template v-for="num_page in begin_available_pages" :key="'num_page_' + num_page">
        <a @click="changePage(num_page)" aria-current="page" :class="num_page == current_page
            ? 'relative z-10 inline-flex items-center bg-lime-600 px-4 py-2 text-sm font-semibold text-white focus:z-20 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-lime-600'
            : 'cursor-pointer relative inline-flex items-center px-4 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0'
          ">{{ num_page }}</a>
      </template>

      <span v-if="num_pages > 6 && begin_available_pages.slice(-1) < num_pages - 2"
        class="relative inline-flex items-center px-4 py-2 text-sm font-semibold text-gray-700 ring-1 ring-inset ring-gray-300 focus:outline-offset-0">...</span>
      <template v-for="num_page in end_available_pages" :key="'num_page_' + num_page">
        <a @click="changePage(num_page)" aria-current="page" :class="num_page == current_page
            ? 'relative z-10 inline-flex items-center bg-lime-600 px-4 py-2 text-sm font-semibold text-white focus:z-20 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-lime-600'
            : 'cursor-pointer relative inline-flex items-center px-4 py-2 text-sm font-semibold text-gray-900 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0'
          ">{{ num_page }}</a>
      </template>
      <a @click="
        changePage(current_page < num_pages ? current_page + 1 : current_page)
        "
        class="cursor-pointer relative inline-flex items-center rounded-r-md px-2 py-2 text-gray-400 ring-1 ring-inset ring-gray-300 hover:bg-gray-50 focus:z-20 focus:outline-offset-0">
        <span class="sr-only">Next</span>
        <i class="fas fa-chevron-right" aria-hidden="true" />
      </a>
    </nav>
  </div>
</template>
<script>
export default {
  name: "TablePaginator",
  data() {
    return {
      current_page: this.modelValue || this.init_current_page,
      begin_available_pages: [3],
      end_available_pages: [],
      num_pages: 0,
    };
  },
  props: {
    modelValue: null,
    rows_per_page: { type: Number, default: 10 },
    init_current_page: { type: Number, default: 1 },
    total_rows: { type: Number, default: 0, required: true },
  },
  methods: {
    changePage(page) {
      this.current_page = page;
    },
  },
  created() {
    this.num_pages = Math.ceil(this.total_rows / this.rows_per_page);
    if (this.num_pages > 7) {
      this.begin_available_pages = Array.from({ length: 5 }, (_, i) => i + 1);
      this.end_available_pages = Array.from(
        { length: 2 },
        (_, i) => this.num_pages - i
      ).reverse();
    } else {
      this.begin_available_pages = Array.from(
        { length: this.num_pages },
        (_, i) => i + 1
      );
    }
  },

  watch: {
    current_page: function (newValue) {
      this.$emit("update:modelValue", newValue);
      if (this.num_pages > 7 && newValue > 3 && newValue < this.num_pages - 3) {
        this.begin_available_pages = Array.from(
          { length: 5 },
          (_, i) => i + newValue - 2
        );
      } else if (this.num_pages > 7 && newValue <= 3) {
        this.begin_available_pages = Array.from(
          { length: 5 },
          (_, i) => i + 1
        );
      }
    },
  },
};
</script>
